import { Component } from '@angular/core';
import { DetailInfoTypeComponent } from '../detail-info-type.component';

@Component({
    selector: 'detail-info-toggle',
    templateUrl: './detail-info-toggle.component.html',
    standalone: false
})
export class DetailInfoToggleComponent extends DetailInfoTypeComponent {
  ngOnInit() {
    super.ngOnInit();
    // if (!this.formControlObj) {
    //   return;
    // }
    // if (this.formControlObj.value === "false" || this.formControlObj.value === false) {
    //   this.formControlObj.patchValue(false);
    // } else if (this.formControlObj.value === "true" || this.formControlObj.value === true) {
    //   this.formControlObj.patchValue(true);
    // }
  }
}